<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
	    <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">
																		{{meta.title}}
                                    <span>{{meta.section}}</span>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="p-4">
												<component class="my-4" 
													:is="component" 
													@data-to-parent="updateWithChildData"
													v-if="component" />
                        <div v-if="meta.section == 'technology' || meta.section == 'service'" class="row justify-content-start">
                            <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                                <div class="card-profile-actions py-4 mt-0">
                                    <a href="#/contact" class="btn btn-info mr-4">Get in touch</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {
	name: "dynamic-page",
	data: function() {
		return {
			meta: '',
			component: null,
		}
	},
	computed: {
		loader: function() {
			if( !this.$route.name ) {
				return null;
			}
			return () => import(`./pages/${this.$route.name}`);
		}
	},
	methods: {
		updateWithChildData: function (data) {
			this.meta = data;
		}
	},
	watch: { '$route' (to, from) {
		this.loader()
			.then(() => {
				this.component = () => this.loader()
			})
			.catch(() => {
				console.log("page not found")
				this.component = () => import('./pages/page_not_found')
			})
	}},
	mounted: function () {
		this.loader()
			.then(() => {
				this.component = () => this.loader()
			})
			.catch(() => {
				console.log("page not found")
				this.component = () => import('./pages/page_not_found')
			})
	},


};
</script>
<style>
</style>
